<template>
  <div>
    <div class="readComplete anim" v-if="isShow" @click="pay()">
      ￥{{ this.resultpage_price }} 解锁8000字专业报告
    </div>
    <div @click="goHome()" class="back anim" v-if="isShow">返回首页</div>
  </div>
</template>
<script>
import store from "../../../../store";
import { getTestRes, paychase } from "@/http/api";
import "./anim.css";
export default {
  data() {
    return {
      isShow: false,
      showBuy: false,
      userInfo: JSON.parse(localStorage.getItem("vuex")),
      //这是结果页ID
      appraisal_id: "",
      //这是需要支付的费用
      //    resultpage_price:-1,
      scrollTop: -1,
      canWatch: false,
    };
  },
  props: ["resultpage_price", "lock_status"],
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.appraisal_id = store.state.appraisal_id;
  },
  mounted() {
    this.handleScroll();
  },
  destroyed() {
    this.canWatch = false;
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    //    openShow(){
    //        this.isShow = true
    //    },
    //    toPay(){
    //         this.isShow = false
    //         this.$parent.isFixed = false
    //    },
    goHome() {
      this.$router.push("/index");
    },
    pay() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) != "micromessenger") {
        // if(localStorage['env'] == 'notWechat'){
        let param = {
          pay_type: "resultpage",
          payment: "ali_pay",
          evaluation: this.userInfo.eval_id,
          amount: this.resultpage_price,
          note: this.appraisal_id,
          inviter_id: "",
        };
        h5paychase(param).then((res) => {
          if (res.code == "SUCCESS") {
            console.log(res.data.pay_url);
            if (res.data.pay_url) {
              window.location.replace(res.data.pay_url);
            }
            //让页面正常显示
            this.isShow = false;
            this.$parent.isFixed = false;
            this.canWatch = true;
          }
        });
      } else {
        let param = {
          pay_type: "resultpage",
          evaluation: this.userInfo.eval_id,
          amount: this.resultpage_price,
          // amount:0.01,
          inviter_id: "",
          note: this.appraisal_id,
        };
        paychase(param).then((res) => {
          console.log("结果页的支付", res);
          console.log("2021年7月9日10:38:03");
          let data = res.data.pay_params;
          let appId = data.appId;
          let timeStamp = data.timeStamp;
          let nonceStr = data.nonceStr;
          // let signature = data.signature;
          let packages = data.package;
          let paySign = data.paySign;
          // this.code = res.data.redeem_code;
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appId, //公众号名称，由商户传入
              timeStamp: timeStamp, //时间戳，自1970年以来的秒数
              nonceStr: nonceStr, //随机串
              package: packages,
              signType: "MD5", //微信签名方式：
              paySign: paySign, //微信签名
            },
            (res) => {
              console.log(res);
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                this.$message({
                  message: "支付成功",
                  type: "success",
                });
                // let coupon = {
                //     amount: 0,
                //     condition: 0,
                // };
                //让页面正常显示
                this.isShow = false;
                this.$parent.isFixed = false;
                this.canWatch = true;
                // store.commit("set_coupon", coupon);
                // setTimeout(() => {
                //     this.show = false;
                //     this.showCoupon = true;
                //     console.log(this.showCoupon);
                // }, 1000);
              } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                this.$message({
                  message: "您已取消支付",
                  type: "error",
                });
              } else {
                this.$message({
                  message: "支付失败",
                  type: "error",
                });
              }
            }
          );
        });
      }

      // }

      // }
    },
    handleScroll(e) {
      console.log("2021年7月9日15:12:35");
      console.log(e.target.scrollTop);
      this.scrollTop = e.target.scrollTop;
      if (this.scrollTop >= 300) {
        console.log(123);
        if (
          (this.resultpage_price == 0 && this.lock_status == "out") ||
          this.canWatch
        ) {
          console.log("我是0");
          this.isShow = false;
          this.$parent.isFixed = false;
        } else {
          console.log("我不是0");
          this.isShow = true;
          this.$parent.isFixed = true;
        }
      } else {
        this.isShow = false;
      }
    },
  },
};
</script>
<style scoped lang="less">
.readComplete {
  position: fixed;
  bottom: 116px;
  // left: calc(50%-118px);
  left: 50%;
  transform: translateX(-50%);
  width: 236px;
  height: 45px;
  background-color: #f5a623;
  border-radius: 10px;
  line-height: 45px;
  text-align: center;
  color: #fff;
  z-index: 999;
}
.readComplete:hover {
  background-color: pink;
}
.back {
  position: fixed;
  bottom: 87px;
  width: 79px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 10%;
  background-color: skyblue;
  color: #fff;
  // left: calc(50%-118px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
</style>